module.exports = __webpack_public_path__ + "static/img/bg_h1.cdc62f19.jpg";